import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Calendar, Events, Calendars } from "./types.js";
import { calendarView } from "./funcs.js";
addProp(_User, "calendar", Calendar, "calendar");
addProp(_User, "calendars", Calendars, "calendars");
addProp(_User, "events", Events);
_User.prototype.calendarView = calendarView;
//# sourceMappingURL=users.js.map